import { HttpErrorResponse } from "@angular/common/http";

export class ServicoCartaoIndisponivelError extends Error {
  status: number;
  originalError: HttpErrorResponse;

  constructor(originalError?: HttpErrorResponse , message?: string) {
    super(message ?? 'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.');
    this.name = 'ServicoCartaoIndisponivelError';
    this.originalError = originalError ?? null;
    this.status = originalError?.status ?? null;
    Object.setPrototypeOf(this, ServicoCartaoIndisponivelError.prototype);
  }
}